import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/dev-landing/src/img/icons/mir.svg");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/dev-landing/src/img/icons/mobile.svg");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/dev-landing/src/img/icons/sber.svg");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/dev-landing/src/img/icons/sbp.svg");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/dev-landing/src/img/icons/tinkoff.svg");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/dev-landing/src/img/icons/vk.svg");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/dev-landing/src/img/tools/dzen.svg");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/dev-landing/src/img/tools/odnoklassniki.svg");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/dev-landing/src/img/tools/ula.svg");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/dev-landing/src/img/tools/vk-cloud.svg");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/dev-landing/src/img/tools/vk-mail.svg");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/vk-store-web-catalog/src/app/favicon.ico");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/vk-store-web-catalog/src/components/AppsWithPagination/AppsWithPagination.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/vk-store-web-catalog/src/components/AppsWithPagination/parts/AppsList/AppsList.tsx");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/vk-store-web-catalog/src/components/MainPageContent/MainPageContent.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["AsideMenu"] */ "/builds/RuStore-Web/monoland/apps/vk-store-web-catalog/src/components/MainPageContent/parts/AsideMenu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScrollTop"] */ "/builds/RuStore-Web/monoland/apps/vk-store-web-catalog/src/components/MainPageContent/ScrollTop.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Banner"] */ "/builds/RuStore-Web/monoland/apps/vk-store-web-catalog/src/components/NewMainPage/parts/Ads/Banner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AppsCarousel"] */ "/builds/RuStore-Web/monoland/apps/vk-store-web-catalog/src/components/NewMainPage/parts/AppsCarousel/AppsCarousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AppsCarouselFromSelection"] */ "/builds/RuStore-Web/monoland/apps/vk-store-web-catalog/src/components/NewMainPage/parts/AppsCarousel/AppsCarouselFromSelection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ArticleCard"] */ "/builds/RuStore-Web/monoland/apps/vk-store-web-catalog/src/components/NewMainPage/parts/Articles/ArticleCard.tsx");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/vk-store-web-catalog/src/components/NewMainPage/parts/Articles/Articles.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["Categories"] */ "/builds/RuStore-Web/monoland/apps/vk-store-web-catalog/src/components/NewMainPage/parts/Categories/Categories.tsx");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/vk-store-web-catalog/src/components/NewMainPage/parts/CategoryAppsList/CategoryAppsList.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["Events"] */ "/builds/RuStore-Web/monoland/apps/vk-store-web-catalog/src/components/NewMainPage/parts/Events/Events.tsx");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/vk-store-web-catalog/src/components/NewMainPage/parts/Layout/Layout.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["SelectionCard"] */ "/builds/RuStore-Web/monoland/apps/vk-store-web-catalog/src/components/NewMainPage/parts/SelectionsWithCovers/SelectionCard.tsx");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/vk-store-web-catalog/src/components/NewMainPage/parts/SelectionsWithCovers/SelectionsWithCovers.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["SelectionWithScreenshots"] */ "/builds/RuStore-Web/monoland/apps/vk-store-web-catalog/src/components/NewMainPage/parts/SelectionWithScreenshots/SelectionWithScreenshots.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ViewReporter"] */ "/builds/RuStore-Web/monoland/apps/vk-store-web-catalog/src/components/NewMainPage/parts/ViewReporter/ViewReporter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["logBreadcrumbsItemClick"] */ "/builds/RuStore-Web/monoland/apps/vk-store-web-catalog/src/utils/analytics/breacrumbsAnalytics.ts");
;
import(/* webpackMode: "eager", webpackExports: ["onSocialClick","onFooterClick"] */ "/builds/RuStore-Web/monoland/apps/vk-store-web-catalog/src/utils/analytics/footerAnalytics/index.ts");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/node_modules/jotai/esm/react.mjs");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/packages/shared/NewPagination/DirectionButton.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/packages/shared/NewPagination/NewPagination.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/packages/shared/NewPagination/PageButton.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/packages/shared/Scroller/Scroller.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Breadcrumbs"] */ "/builds/RuStore-Web/monoland/packages/ui-kit/src/Breadcrumbs/Breadcrumbs.tsx");
